import { useEffect, useRef, useState } from "react";
import AddIcon from '@mui/icons-material/Add';
import ProgressBarODM from "./ProgressBar";
import { assetti, esecuzioni, Esercizio, finalita, modalita } from "../interfaces/Esercizio";
import CompartiMuscolari, { comparti } from "./CompartiMuscolari";
import ImageUploadPreview from "./ImageUploadPreview";
import ModalPosizioneFinalita from "./ModalPosizioneFinalità";
import ComplexFunctionModal from "./ComplexFunctionModal";
import ModeIcon from '@mui/icons-material/Mode';
import IssueHandlingModal from "./IssueHandlingModal";
import ReminderModal from "./ReminderModal";
import { Box, Checkbox, Chip, FormControl, InputLabel, ListItemText, MenuItem, OutlinedInput, Select, TextField } from "@mui/material";
import ParametriValutativi from "./ParametriValutativi";
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import VideoTrack from "./VideoTrack";
import JsonUpload from "./JsonUpload";
import Video3DTrack from "./Video3DTrack";

import strechingHuman from "../assets/icons/strechingHuman.svg"
import elasticBand from "../assets/icons/elasticBand.svg"
import elasticRope from "../assets/icons/elasticRope.svg"
import doubleHandleMedicineBall from "../assets/icons/doubleHandleMedicineBall.svg"
import barbell from "../assets/icons/barbell.svg"
import dumpbell from "../assets/icons/dumpbell.svg"
import bench from "../assets/icons/bench.svg"
import foamRoller from "../assets/icons/foamRoller.svg"
import disk from "../assets/icons/disk.svg"
import broomStick from "../assets/icons/broomStick.svg"

interface SportEducativoDetailsProps {
    //token: string;
    esercizio: Esercizio;
    handleChange: <K extends keyof Esercizio>(key: K, value: Esercizio[K]) => void;
}

interface ReminderOption {
    id: number | null;
    name: string;
    description: string;
}

interface select {
    value: string;
    label: string;
}


const iconMap: any = {
    elasticBand,
    elasticRope,
    doubleHandleMedicineBall,
    barbell,
    dumpbell,
    bench,
    foamRoller,
    disk,
    broomStick
};


export default function SportEducativoDetailsFast({ esercizio, handleChange }: SportEducativoDetailsProps) {
    const fileInputRef = useRef<HTMLInputElement | null>(null);


    const [modalEF, setModalEF] = useState<boolean>(false);
    const [modalComplexFunction, setModalComplexFunction] = useState<boolean>(false);
    const [modalIssues, setModalIssues] = useState<boolean>(false);
    const [modalReminder, setModalReminder] = useState<boolean>(false);

    const [reminderOptions, setReminderOptions] = useState<ReminderOption[]>([]);
    const [categoryList, setCategoryList] = useState<select[]>([]);

    const fetchCategory = async () => {
        try {
            const headers = new Headers();
            //if (token) {
            //    headers.set('Authorization', `Token ${token}`);
            //}
            headers.set('Accept', 'application/json');
            const requestInit: RequestInit = {
                method: 'GET',
                headers: headers,
                credentials: 'include',
            }
            const response = await fetch('/api/v0/activity/categories', requestInit);
            if (!response.ok) throw new Error('Errore nel recupero delle attività');
            const data = await response.json();
            setCategoryList(data);
        } catch (err: any) {
            console.log(err.message);
        }
    };

    useEffect(() => {
        fetchCategory()
    }, []);

    return (
        <div className="mt-3 p-3 bg-white shadow-md rounded-lg max-w-lg mx-auto" style={{ height: "76vh", overflowY: "auto" }}>
            <div className="d-flex mt-1 mb-4">
                <button className="btn btn-dark me-2" onClick={() => setModalEF(!modalEF)}>
                    <AddIcon />
                </button>
                <ModalPosizioneFinalita
                    open={modalEF}
                    onClose={() => setModalEF(false)}
                    esercizio={esercizio}
                    positionChange={(e) => handleChange("position", e.value)}
                    purposeChange={(e) => handleChange("purpose", e.value)}
                />
                <TextField
                    disabled
                    fullWidth
                    variant="outlined"
                    size="small"
                    className="form-control"
                    label="Posizione*"
                    value={esercizio.position}

                />
                <div className="m-1">
                    <ArrowForwardIosIcon />
                </div>
                <TextField
                    disabled
                    fullWidth
                    variant="outlined"
                    size="small"
                    className="form-control"
                    label="Finalità*"
                    value={finalita.map((option) =>
                        esercizio.purpose === option.value ? option.name : undefined
                    ).filter(Boolean)}
                />
            </div>

            <TextField
                label="Nome corto*"
                variant="outlined"
                size="small"
                fullWidth
                value={esercizio.full_name}
                onChange={(e) => handleChange("full_name", e.target.value)}
                inputProps={{ maxLength: 35 }}
                helperText={`${esercizio.full_name.length}/35`}
                FormHelperTextProps={{ style: { textAlign: 'right' } }}
                className="mb-2"
            />
            <TextField
                label="Descrizione*"
                variant="outlined"
                size="small"
                fullWidth
                multiline
                minRows={2}
                value={esercizio.full_description}
                onChange={(e) => handleChange("full_description", e.target.value)}
                InputProps={{
                    sx: {
                        maxHeight: 300,
                        overflow: "auto"
                    }
                }}
                inputProps={{
                    maxLength: 250,
                    style: {
                        maxHeight: 300
                    }
                }}
                helperText={`${esercizio.full_description.length}/250`}
                FormHelperTextProps={{ style: { textAlign: 'right' } }}
                className="mb-2"
            />

           <div className="row">
                <div className="col-5 d-flex mb-3">
                    <input
                        disabled
                        className="form-control me-3"
                        placeholder="Posizione*"
                        value={esercizio.position}
                    />
                    <button className="btn btn-dark" onClick={() => setModalEF(!modalEF)}>
                        <AddIcon />
                    </button>
                    <ModalPosizioneFinalita
                        //token={token}
                        open={modalEF}
                        onClose={() => setModalEF(false)}
                        esercizio={esercizio}
                        positionChange={(e) => handleChange("position", e.value)}
                        purposeChange={(e) => handleChange("purpose", e.value)}
                    />
                </div>
            </div>

            <div className="mb-4">
                <h5 className="font-semibold mb-1">Categoria</h5>
                <select
                    className="form-control"
                    value={esercizio.category}
                    onChange={(e) => handleChange("category", e.target.value)}
                >
                    {categoryList.map((option) => (
                        <option key={option.value} value={option.value}>
                            {option.label}
                        </option>
                    ))}
                </select>
            </div>
 

            <div className="mb-3">
                <h5 className="font-semibold mb-3">Immagine di anteprima</h5>
                <ImageUploadPreview
                    //token={token}
                    image={esercizio.preview_image}
                    onChange={(newImage) => handleChange("preview_image", newImage)}
                />
            </div>
            <div className="mb-3">
                <VideoTrack
                    title="Video"
                    description="Assicurati che il video riproduca una singola ripetizione dell'esercizio in quanto questa verrà ripetuta in loop sull'app."
                    acceptedFileType="video/mp4"
                    file={esercizio.video}
                    field="video"
                    handleChange={handleChange}
                    fast={true}
                />
            </div>

        </div>

    );
}